import {Component, Input, ViewEncapsulation} from '@angular/core';

export type CircleMode = 'success' | 'warning' | 'error' | 'falsevalue' | 'primary' | 'none' | 'critical' | 'inverse' | 'black';
export type CircleSize = 'mini' | 'small' | 'normal' | 'big';


@Component({
    selector: 'in-type-circle',
    templateUrl: './type-circle.component.html',
    styleUrls: ['./type-circle.component.scss'],
    providers: [],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class TypeCircleComponent {


  @Input() label = '';
  @Input() title = '';
  @Input() icon = '';
  @Input() showLabel = true;
  @Input() mode: CircleMode = 'success';
  @Input() size: CircleSize = 'normal';
  @Input() content: any = '';

}
